<template>
    <section class="container">
        <div class="row">
            <admin-member-modal/>
            <level-modal/>
            <div class="col-md-2" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                <adminSidenav></adminSidenav>
            </div>
            <div class="col">
                <div class="container">
                    <h4>
                        멤버 목록
                    </h4>

                    <div class="input-group col-sm-12">
                        <div class="col-md-12">
                            레벨 
                            <button type="button" class="btn btn-outline-secondary btn-sm py-0 px-1 ml-1 mr-2" @click="levelInfo()" title="레벨 안내">ⓘ</button>
                            <span v-for="l in $root.$children[0].getLevel()">
                                <input type="checkbox" width="30px" v-model="filterLevels"  :value="l.level"> {{l.name}} &nbsp;
                            </span>

                        </div>
                        <div class="col-md-12">
                            특기 : &nbsp;
                            <span v-for="s, k in $root.$children[0].getSpMap()">
                                <input type="checkbox" width="30px" v-model="filterSpecs" :value="k"> {{s}} &nbsp;
                            </span>
                        </div>
                        <div class="col-md-12">
                            권한 : &nbsp;
                            <span v-for="r, k in memberRoles">
                                <input type="radio" name="roles" width="30px" v-model="filterRoles" :value="k"> {{r}} &nbsp;
                            </span>
                        </div>


                        <div class="col-md-12">
                            활동참여 : &nbsp;
                            <span>
                                <input type="checkbox" width="30px" @click="toggleFilterStatus" v-model="statusAll"> 전체 &nbsp;
                            </span>
                            <span v-for="r, k in statusMap">
                                <input type="checkbox" width="30px" @click="setAllStatus" v-model="filterStatus" :value="k"> {{r}} &nbsp;
                            </span>
                        </div>
                        <div class="col-md-12">
                            활동년도 : &nbsp;
                            <span>
                                <input name="actYears" type="radio" width="30px" v-model="filterActYears" :value="''" > 전체
                            </span>
                            <span v-for="r in years()">
                                <input name="actYears" type="radio" width="30px" @click="checkFilterStatus" v-model="filterActYears" :value="r"> {{r}} &nbsp;
                            </span>
                        </div>
                      <div class="col-md-12">

                            활동분류 : &nbsp;
                            <span>
                                <input name="actCate" type="radio" width="30px" v-model="filterCategory" :value="''" > 전체
                            </span>
                            <span v-for="c in $root.$children[0].category">
                                <input name="actCate" type="radio" width="30px"  @click="checkFilterStatus" v-model="filterCategory" :value="c.code"> {{c.name}} &nbsp;
                            </span>
                        </div>
                        <div class="col-md-12">
                            가입년도 : &nbsp;
                            <span>
                                <input name="regYears" type="radio" width="30px" v-model="filterRegYears" :value="''" > 전체
                            </span>
                            <span v-for="r in years()">
                                <input name="regYears" type="radio" width="30px" v-model="filterRegYears" :value="r"> {{r}} &nbsp;
                            </span>
                        </div> <!-- -->
                    </div>
                  <hr>
                  <div class="input-group col-sm-12 col-md-6 pull-right my-1">
                    <select v-model="page.size" @change="searchMember">
                      <option value="5">5개씩보기</option>
                      <option value="10">10개씩보기</option>
                      <option value="20">20개씩보기</option>
                      <option value="30">30개씩보기</option>
                      <option value="40">40개씩보기</option>
                      <option value="50">50개씩보기</option>
                    </select>
                    <input type="text" class="form-control" v-model="filterName" placeholder="이름 검색"  aria-describedby="button-addon2" @keyup.enter="searchMember()" >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="searchMember()" >검색</button>
                    </div>
                    &nbsp;
                  </div>총 {{memberList.length}}/{{totalCount}} 명
                  <table class="table text-center">
                        <thead>
                        <tr>
                            <th @click="chnageSortOrder('level')">Lv <span v-show="page.sort === 'level'">{{page.order === 'desc' ? '▽' : '△'}}</span></th>
                            <th @click="chnageSortOrder('name')" width="25%">이름 <span v-show="page.sort === 'name'">{{page.order === 'desc' ? '▽' : '△'}}</span></th>
                            <th>나이/성별</th>
                            <th>특기</th>
                            <th>후원</th>
                            <th class="d-none d-lg-table-cell" width="35%">연락처</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="!!!memberList">
                            <th colspan="100%"> 회원이 없습니다.</th>
                        </tr>
                        <tr v-else v-for="member in memberList"> <!--  carousel-item active -->
                            <td :title="member.volunteerMinute">
                                Lv.{{member.level}}
                                <span v-if="levelObj(member.level)" class="badge badge-pill" :style="`color:white;background-color:`+levelObj(member.level).color">
                                    {{levelObj(member.level).name}}
                                </span>
                            </td>

                            <td @click="memberModal(member.id)">
                                <img @error="member.profileImage=require('@/assets/img/profile_base.png')" :src="member.profileImage ?  member.profileImage : require('@/assets/img/profile_base.png')" alt="profile Image" style="width:30px; height:30px;" class="img-profile rounded-circle">
                                {{member.name}}
                            </td>
                            <td>{{$root.$children[0].getAge(member.age)}}/{{member.gender === 'MALE' ? '남' : (member.gender === 'FEMALE' ? '여' : '기타')}}</td>
                            <td>
                                <div v-if="member.specialities.length > 0">
                                <span v-for="spec in member.specialities">
                                    {{$root.$children[0].getSpMap()[spec]}}
                                </span>
                                </div>
                                <span v-if="member.specialities.length === 0">없음</span>
                            </td>
                            <td>
                              {{member.isKaraRegularMember ? 'Y' : 'N'}}
                            </td>
                          <td class="d-none d-lg-table-cell introduce">
                                <div class="txt_line" :title="member.introduce">{{member.phoneNumber}}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <button class="btn btn-sm btn-outline-danger float-right" type="button" @click="exportMemberCsv()" >csv 다운로드</button>

                    <paginate :page-count="totalPage" :click-handler="clickCallback" :prev-text="'<'" :next-text="'>'"
                              :container-class="'pagination'"
                              :page-class="'page-item'"
                              :page-link-class="'page-link-item'"
                              :prev-class="'prev-item'"
                              :prev-link-class="'prev-link-item'"
                              :next-class="'next-item'"
                              :next-link-class="'next-link-item'"
                              :break-view-class="'break-view'"
                              :break-view-link-class="'break-view-link'">
                        <span slot="breakViewContent">
                          <svg width="16" height="4" viewBox="0 0 16 4">
                            <circle fill="#999999" cx="2" cy="2" r="2" />
                            <circle fill="#999999" cx="8" cy="2" r="2" />
                            <circle fill="#999999" cx="14" cy="2" r="2" />
                          </svg>
                        </span>
                    </paginate>

                </div>
            </div>
        </div>
    </section>

</template>

<script>

    import adminSidenav from '@/components/admin/Sidenav.vue'
    import AdminMemberModal from '@/components/admin/AdminMemberModal.vue'
    import LevelModal from '@/components/LevelModal.vue'
    import { saveAs } from 'file-saver';
    export default {
        name: 'memberManage',
        data() {
            return {
                filterSpecs: [],
                filterLevels: [],
                filterRoles: [],
                filterName : "",

                statusAll : false,
                filterStatus :[],
                filterActYears :"",
                filterRegYears :"",
                filterCategory : '',

                memberList: [],
                memberRoles : [],
                statusMap: {},
                page:{
                    nowPage:0,
                    size:10,
                    sort:'id',
                    order:'desc',
                },
                totalCount : 0,
                totalPage : 0
            }
        },
        components: {
            adminSidenav,AdminMemberModal,LevelModal
        },
        computed : {

        },
        watch: {
          "filterStatus": function (val) {
            // 상태 선택이 없으면 년도 체크도 없음
            if(this.filterStatus.length == 0)
              this.filterActYears = '';
          },
        },
        methods: {
            levelObj(level) { // 레벨 번호로 레벨 정보 조회 (예: 1 -> {name:'새내기', color:...})
                return this.$root.$children[0].getLevel().find(l => l.level === level);
            },
            levelInfo() { // 레벨 구간 안내 모달
                this.$modal.show('LevelModal')
            },
            checkFilterStatus() { // 년도 체크시 상태 체크 확인
              if(this.filterStatus.length == 0){
                this.statusAll = true;
                this.filterStatus = Object.keys(this.statusMap);
              }
            },
            setAllStatus() { // 전체 체크박스 조정
              // 하나라도 선택 안하면 전체 선택 해제
              if(this.filterStatus.length !== this.statusMap.length)
                this.statusAll = false;

            },
            toggleFilterStatus() { // 상태 전체 선택 토글
              if(this.statusAll) {
                 this.filterStatus = [];
              } else this.filterStatus = Object.keys(this.statusMap);

              this.setAllStatus();
            },
            years () {
                const year = new Date().getFullYear()+1;
                return Array.from({length: year - 2020}, (value, index) => 2020 + index)
            },
            async getStatusMap() {
                let me = this;
                let url = process.env.VUE_APP_ADMIN_API_URL + `/activity/member/status`;
                //console.log(u);
                await this.axios.get(url)
                    .then(function (res) {
                        me.statusMap = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            chnageSortOrder(col) {
              if(col ===  this.page.sort)
                this.page.order = ('desc' === this.page.order) ? 'asc' : 'desc';
              this.page.sort = col;
              this.searchMember();
            },
            getMemberRoles() {
                let me = this;
                this.axios.get(process.env.VUE_APP_ADMIN_API_URL + `/activity/members/roles`)
                    .then(function (res) {
                        me.memberRoles = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            memberModal(id){
                let me = this;
                this.axios.get(process.env.VUE_APP_MEMBER_API_URL + `/${id}`)
                    .then(function (res) {
                        me.$modal.show('AdminMemberModal', {'member':res.data})
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            searchMember(){
                let me = this;
                this.axios.get(process.env.VUE_APP_ADMIN_API_URL + `/activity/members/search?name=${this.filterName}&roles=${this.filterRoles}&specs=${this.filterSpecs}&levels=${this.filterLevels}`+
                        `&actStatus=${this.filterStatus}&regYears=${this.filterRegYears}&actYears=${this.filterActYears}&actCategory=${this.filterCategory}`+
                `&page=${this.page.nowPage}&size=${this.page.size}&sort=${this.page.sort},${this.page.order}`)
                    .then(function (res) {
                        me.memberList = res.data.result;
                        me.totalCount = res.data.totalCount;
                        me.totalPage = res.data.totalPage;
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },
            exportMemberCsv(){
                let me = this;
                this.axios({
                    url: process.env.VUE_APP_ADMIN_API_URL + `/members/export?name=${this.filterName}&roles=${this.filterRoles}&specs=${this.filterSpecs}&levels=${this.filterLevels}`+
                        `&actStatus=${this.filterStatus}&regYears=${this.filterRegYears}&actYears=${this.filterActYears}&actCategory=${this.filterCategory}`,
                    method: 'GET',
                    //responseType: 'blob', // important

                }).then((response) => {
                    let BOM = "\uFEFF";
                    let csvData = BOM + response.data;

                    let blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
                    saveAs(blob, me.$root.$children[0].moment().format('YYYY-MM-DD_') + 'members.csv');
                });
            },
            clickCallback (pageNum) {
                this.page.nowPage = pageNum-1;
                this.searchMember()
            }

        },
        async mounted() {

            this.getMemberRoles();
            await this.getStatusMap();

            if(this.$route.params.statusAll) {
              this.statusAll = true//this.$route.params.statusAll;
              this.filterStatus = Object.keys(this.statusMap);
            }

            if(this.$route.params.year) {
              this.filterActYears = this.$route.params.year;
            }
            if(this.$route.params.regYear) {
              this.filterRegYears = this.$route.params.regYear;
            }

            this.searchMember();


        },
        created() {

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .introduce{
        word-break:break-all;
    }
    .txt_line {
        width:250px;
        padding:0 5px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }

    .pagination .active {
        color:red;
        font-weight: bolder;
    }
</style>
